module.exports = __webpack_public_path__ + "static/img/lineup_cmt_c_mango.5394536.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/lineup_cmt_c_mango.svg
// module id = o0IZ
// module chunks = 1